import classNames from 'classnames'
import React from 'react'
import { useLocation } from 'react-router-dom'
import parseUrl from 'url-parse'
import { MenuItem } from '../../constants/menuItems'
import { LogoutIcon } from '../svgs/ExpressonSVGs'
import Button from './Button'
import Link from './Link'

const DASHBOARD_PATH = 'mitt-konto/dashboard'
const ACCOUNT_PATH = 'mitt-konto'
const USER_MANAGEMENT_PATH = 'hantera-anvandare'

type Props = {
  headerItems: MenuItem[]
  sideItems: MenuItem[]
  isCompany: boolean
  transparent?: boolean
  hasSmartCards?: boolean
  hasCreditCards?: boolean
}

const Menu: React.FC<Props> = ({
  headerItems,
  sideItems,
  isCompany,
  transparent,
  hasSmartCards = false,
  hasCreditCards = false
}) => {
  const location = useLocation()

  /**
   * Prettifies the user's name for display.
   *
   * @param name The name to prettify.
   * @returns The prettified name.
   */
  const prettyfyName = (name: string) => {
    if (!name) {
      return 'Användare'
    }
    const newName = name.split(' ').map((singleName) => (
      singleName = singleName.charAt(0).toUpperCase() + singleName.slice(1).toLowerCase()
    )).join(' ')
    return newName;
  }

  return (
    <nav
      className={classNames({
        Menu: true,
        'Menu--Transparent': transparent
      })}
    >
      <div className="Menu__Child Menu__LogoContainer">
        <Link href="/">
          <img
            alt="Qstars logotyp"
            className="Menu__Logo"
            src="/static/images/qstar_logo_yellow.png"
          />
        </Link>
      </div>
      <ul className="Menu__Child List--Unstyled Menu__Items Menu__Items--Navigation">
        {headerItems.map((item) => {
          const itemClass = classNames(
            'Menu__Item',
            item.url && {
              'Menu__Item--Active':
                parseUrl(item.url).pathname === location.pathname ||
                location.pathname.includes(`/${item.url}`) ||
                (item.url === DASHBOARD_PATH && location.pathname.includes(`/${ACCOUNT_PATH}`)) ||
                (item.url === DASHBOARD_PATH && location.pathname.includes(`/${USER_MANAGEMENT_PATH}`))
            },
            item.classes
          )
          return (
            <li className={itemClass} key={item.url ? item.url : item.title}>
              <Link ariaLabel={item.title} href={`/${item.url}`}>
                {item.title}
              </Link>
            </li>
          )
        })}
      </ul>
      <ul className="Menu__Child List--Unstyled Menu__Items Menu__Items--Subtle">
        {sideItems.map((item) => {
          return (
            <li
              className={classNames({
                Menu__Item: true,
                'Menu__Item--Cta': item.classes?.includes('Button')
              })}
              key={item.url ? item.url : item.title}
            >
              {
                // If item specically has the shouldBeLink key set to false
                // then render it outside of the button
                // eslint-disable-next-line no-negated-condition
                item.shouldBeLink === false ? (
                  <>
                    <div className={classNames(item.classes)}>
                      <LogoutIcon width={20} height={20} />
                      <p className="ms-2 mb-0">{item.title}</p>
                    </div>
                  </>
                ) : (
                  <Button
                    className={classNames(item.classes, 'dashboard-button')}
                    url={`/${item.url}`}
                    tabIndex={-1}
                    linkFlex={true}
                  >
                    <LogoutIcon width={22} height={22} />
                    {'mitt-konto' === item.url ? (
                      // Sometimes the name is capitalized so this fixes the profile name
                      prettyfyName(item.title)
                    ) : (
                      item.title
                    )
                    }
                  </Button>
                )
              }
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Menu
